import { Typography } from '../Typography';

export const Copyright = () => (
  <Typography type="label" color="muted">
    © 2026 www.mediator.kz | ТОО «mediator»
  </Typography>
);
